module.exports = __webpack_public_path__ + "img/logo.56d390c0.png";